import { EventSource } from '../analyticsService';

export enum EventType {
    COLLECTION_CREATE_DIALOG_OPEN = 'collection_create_dialog_open',
    COLLECTION_CREATE_DIALOG_CLOSE = 'collection_create_dialog_close',
    SAVE_TO_COLLECTION_DIALOG_OPEN = 'save_to_collection_dialog_open',
    SAVE_TO_COLLECTION_DIALOG_CLOSE = 'save_to_collection_dialog_close',
    COLLECTION_EDIT_DIALOG_OPEN = 'collection_edit_dialog_open',
    COLLECTION_EDIT_DIALOG_CLOSE = 'collection_edit_dialog_close',
    COLLECTION_EDIT = 'collection_edit',
    COLLECTION_EDIT_ABANDON = 'collection_edit_abandon',
    COLLECTION_EDIT_OPEN = 'collection_edit_open',
    COLLECTION_UPDATED = 'collection_updated',
    COLLECTION_CREATED = 'collection_created',
    POST_TO_COLLECTION_ADDED = 'post_to_collection_added',
    GENERATE_SUGGESTS = 'generate_suggests',

    PARTNER_REGISTRATION_PAGE_OPEN = 'partner_registration_page_open',
    PARTNER_TYPE_TAB_CLICK = 'partner_type_tab_click',
    PARTNER_REGISTRATION_NEXT_CLICK = 'partner_registration_next_click',
    PARTNER_REGISTRATION_SUBMIT = 'partner_registration_submit',

    REWARD_BUTTON_CLICK = 'reward_button_click',
    REWARD_DETAILS_CLICK = 'reward_details_click',
    REWARD_REGISTER_CLICK = 'reward_register_click',
}

export enum FieldName {
    SHOW_IN_FEED = 'show_in_feed',
    DISPLAY_NAME = 'display_name',
    IS_PUBLIC = 'is_public',
    PARTNER_TYPE = 'partner_type',
}

export enum RelationType {
    COLLECTION_ITEM = 'collection_item',
    CONTAINER = 'container',
    FORM = 'form',
    REWARD = 'reward',
}

export enum ContentType {
    COLLECTION = 'collection',
    POST = 'post',
    FORM_PAGE = 'form_page',
    TAB = 'tab',
    BUTTON = 'button',
}

export interface RelatedContentItem {
    relation_type: RelationType;
    content: {
        id: string;
        type: ContentType;
    };
}

export interface FieldChange {
    field_name: FieldName;
    old_value?: string;
    new_value: string;
}

export interface ContentActionsEvent {
    event_type: EventType;
    time?: string;
    platform?: 'web';
    screen: EventSource;
    related_content: RelatedContentItem[];
    field_changes?: FieldChange[];
    extra_context?: ExtraContext[];
}

export interface ExtraContext {
    key: string;
    value: string;
}
